import globModules from './glob-modules';

function reactComponent(Component, nodeList) {
  const React = require('react'); //eslint-disable-line
  const { createRoot } = require('react-dom/client'); //eslint-disable-line

  nodeList.forEach((node) =>
    createRoot(node).render(<Component {...node.dataset} />)
  );
}

const modules = [
  {
    name: 'tabbed-content',
    loader: () => import('./modules/tabbed-content'),
  },
  {
    name: 'accordion',
    loader: () => import('./modules/accordion'),
  },
  {
    name: 'video',
    loader: () => import('./modules/video')
  },
  {
    name: 'form',
    loader: () => import('./modules/form')
  },
  {
    name: 'icon-card-row',
    loader: () => import('./modules/icon-card-row')
  },
  {
    name: 'content-row-with-media',
    loader: () => import('./modules/content-row-with-media')
  },
  {
    name: 'image-gallery',
    loader: () => import('./modules/image-gallery')
  },
  {
    name: "header",
    loader: () => import('./modules/header')
  },
  {
    name: "marketo-form",
    loader: () => import('./modules/marketo-form')
  },
  {
    name: "icon-cards",
    loader: () => import('./modules/icon-cards')
  },
  {
    name: 'modal-trigger',
    loader: () => import('./modules/modal-trigger'),
  },
  {
    name: 'wistia',
    loader: () => import('./modules/wistia'),
  },
  {
    name: 'product-gallery',
    loader: () => import('./modules/products/product-gallery'),
  },
  {
    name: "alerts-amw",
    loader: () => import('./modules/alerts-amw')
  },
  {
    name: "product-card",
    loader: () => import('./modules/products/product-card')
  },
  { // sample for adding react components
    name: 'results-listing',
    loader: () => import('./modules/results-listing'),
    render: reactComponent
  },
  {
    name: 'blog-listing',
    loader: () => import('./modules/blog-listing'),
    render: reactComponent
  },
  {
    name: 'event-listing',
    loader: () => import('./modules/event-listing'),
    render: reactComponent
  },
  {
    name: 'conditions-listing',
    loader: () => import('./modules/conditions-listing'),
    render: reactComponent
  },
  {
    name: 'press-release-listing',
    loader: () => import('./modules/press-release-listing'),
    render: reactComponent
  },
  {
    name: 'press-release-detail',
    loader: () => import('./modules/press-release-detail'),
  },
  {
    name: 'masthead-social-share',
    loader: () => import('./modules/masthead-social-share'),
  },
  {
    name: 'marketo-button',
    loader: () => import('./modules/marketo-button'),
  },
  {
    name: 'marketo-modal',
    loader: () => import('./modules/marketo-modal'),
  },
  {
    name: 'button',
    loader: () => import('./modules/button'),
  },
  {
    name: 'read-more',
    loader: () => import('./modules/read-more'),
  },
  {
    name: 'standalone-page',
    loader: () => import('./modules/standalone-page'),
  },
  {
    name: 'member-journey-navigation',
    loader: () => import('./modules/member-journey-navigation'),
  },
  {
    name: 'image-carousel',
    loader: () => import('./modules/image-carousel'),
  },
  {
    name: 'employee-testimonials',
    loader: () => import('./modules/employee-testimonials'),
  },
  {
    name: 'news-and-insights',
    loader: () => import('./modules/news-and-insights'),
    render: reactComponent
  },
  {
    name: 'vertical-tabs',
    loader: () => import('./modules/vertical-tabs')
  },
  {
    name: 'anniversary-timeline',
    loader: () => import('./modules/anniversary-timeline')
  },
  {
    name: 'anniversary-impact-carousel',
    loader: () => import('./modules/anniversary-impact-carousel')
  },
  {
    name: 'lho-hero',
    loader: () => import('./lho/lho-hero')
  },
  {
    name: 'lho-providers',
    loader: () => import('./lho/lho-providers')
  },
  {
    name: 'lho-conditions',
    loader: () => import('./lho/lho-conditions')
  },
  {
    name: 'lho-pricing',
    loader: () => import('./lho/lho-pricing')
  },
  {
    name: 'lho-expandable-list',
    loader: () => import('./lho/lho-expandable-list')
  },
  {
    name: 'lho-standard-navbar',
    loader: () => import('./lho/lho-standard-navbar')
  },
  {
    name: 'lho-videos',
    loader: () => import('./lho/lho-videos')
  },
  {
    name: 'lho-quote-slider',
    loader: () => import('./lho/lho-quote-slider')
  },
  {
    name: 'lho-er-hhunit',
    loader: () => import('./lho/lho-er-hhunit')
  },
  {
    name: 'lho-questions-search',
    loader: () => import('./lho/lho-questions-search')
  },
  {
    name: 'lho-tab-nav',
    loader: () => import('./lho/lho-tab-nav')
  },
  {
    name: 'lho-faq-signup-callout',
    loader: () => import('./lho/lho-faq-signup-callout')
  },
  {
    name: 'resource-home-listing',
    loader: () => import('./modules/resource-home-listing'),
    render: reactComponent
  },
  {
    name: 'resource-topic-listing',
    loader: () => import('./modules/resource-topic-listing'),
    render: reactComponent
  },
  {
    name: 'related-resources-row',
    loader: () => import('./modules/related-resources-row'),
    render: reactComponent
  },
];

export default [...globModules, ...modules];
